export function resumoBaixaAgrupada(itens = []) {
    const lista = Array.isArray(itens) ? itens : [];

    const quantidade = lista.length;

    const total = lista.reduce((acc, item) => {
        return acc + Number(item?.valorAberto || 0);
    }, 0);

    return {
        quantidade,
        total: parseFloat(total).toFixed(2),
    };
}
